// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Brand colors matching Energy app (MUI default) */
  --primary: #2563EB;
  --primary-light: #EFF6FF;
  --primary-hover: #1D4ED8;
  --secondary: #10B981;
  
  /* Backgrounds */
  --bg-body: #F5F6FA;
  
  /* Surfaces */
  --surface: #FFFFFF;
  
  /* Text */
  --text-main: #111827;
  --text-muted: #6B7280;
  --text-light: #9CA3AF;
  
  /* Borders & Shadows */
  --border: #E4E7EE;
  --border-focus: #9CA3AF;
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
  --shadow-md: 0 4px 16px rgba(0,0,0,0.08);
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-body);
  color: var(--text-main);
}

*, *::before, *::after {
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;;EAEpB,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,kBAAkB;;EAElB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;;EAErB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,mEAAmE;EACnE,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0FAA0F;EAC1F,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;AACjF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n:root {\n  /* Brand colors matching Energy app (MUI default) */\n  --primary: #2563EB;\n  --primary-light: #EFF6FF;\n  --primary-hover: #1D4ED8;\n  --secondary: #10B981;\n  \n  /* Backgrounds */\n  --bg-body: #F5F6FA;\n  \n  /* Surfaces */\n  --surface: #FFFFFF;\n  \n  /* Text */\n  --text-main: #111827;\n  --text-muted: #6B7280;\n  --text-light: #9CA3AF;\n  \n  /* Borders & Shadows */\n  --border: #E4E7EE;\n  --border-focus: #9CA3AF;\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);\n  --shadow-md: 0 4px 16px rgba(0,0,0,0.08);\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-body);\n  color: var(--text-main);\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
